import { FitScreenOutlined } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { ModelController } from '../manager/ModelController'

type Props = {
  viewManager: ModelController
}

export const FitAllTool = (props: Props) => {
  return (
    <Tooltip
      title={<LocalizedTypography translationKey="project:viewer-fitAll" />}
    >
      <IconButton
        size="small"
        onClick={() => {
          props.viewManager.FitAll()
        }}
      >
        <FitScreenOutlined />
      </IconButton>
    </Tooltip>
  )
}
